import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
class PartnerWebAgentResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.instanceName = null;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: Infinity,
            errorExpiryLength: Infinity,
            invalidIfStale: true
        };
    }
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
}
PartnerWebAgentResource.urlRoot = apiResourceUrl("partnerWeb");
export { PartnerWebAgentResource };
class PartnerWebShortRefResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.applicationNumber = null;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: Infinity,
            errorExpiryLength: Infinity,
            invalidIfStale: true
        };
    }
    pk() {
        return this.shortRef?.toString();
    }
    static detail() {
        return super.detail().extend({
            schema: this,
            method: "POST"
        });
    }
}
PartnerWebShortRefResource.urlRoot = apiResourceUrl("partnerWeb/ref");
export { PartnerWebShortRefResource };
//# sourceMappingURL=PartnerWebResource.js.map